import React from 'react';
import * as XLSX from 'xlsx';
import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function ExcelExportScrapReport({ JsonData }) {
  if (JsonData?.length === 0) {
    return (
      <Button
        variant="contained"
        fullWidth
        color="secondary"
        endIcon={<CloudDownloadIcon />}
      >
        Excel
      </Button>
    );
  }

  const handleExport = () => {
    const ExportData = JsonData.map((item) => ({
      FIS_NO: item.FIS_NO,
      TEKNISYEN: item.TEKNISYEN,
      DURUM: item.DURUM,
      MALZEME_STOK_NO: item.MALZEME_STOK_NO,
      MALZEME: item.MALZEME,
      HURDA_DURUM: item.HURDA_DURUM,
      KRITIK: item.KRITIK,
      ADET: item.ADET,
      ARAC_TAKIP_NO: item.ARAC_TAKIP_NO,
      ISLEM_TARIHI: item.ISLEM_TARIHI,
      ALINMA_DURUM: item.ALINMA_DURUM,
      SONUC_NOTU: item.SONUC_NOTU,
      ESKISI_YOK_ACIKLAMA: item.ESKISI_YOK_ACIKLAMA,
      SURUCU: item.SURUCU,
      PLAKA: item.PLAKA,
      ARAC_TESLIM_TARIHI: item.ARAC_TESLIM_TARIHI,
    }));

    // Başlıklar (label) ve veriler (value)
    const headers = [
      { label: 'FişNo', value: 'FIS_NO' },
      { label: 'Teknisyen', value: 'TEKNISYEN' },
      { label: 'Durum', value: 'DURUM' },
      { label: 'MalzemeStokNo', value: 'MALZEME_STOK_NO' },
      { label: 'Malzeme', value: 'MALZEME' },
      { label: 'MalzemeEskisiDurum', value: 'HURDA_DURUM' },
      { label: 'Kritik', value: 'KRITIK' },
      { label: 'Adet', value: 'ADET' },
      { label: 'AraçTakipNo', value: 'ARAC_TAKIP_NO' },
      { label: 'İşlemTarihi', value: 'ISLEM_TARIHI' },
      { label: 'AlınmaDurum', value: 'ALINMA_DURUM' },
      { label: 'SonucNotu', value: 'SONUC_NOTU' },
      { label: 'EskisiYokAçıklama', value: 'ESKISI_YOK_ACIKLAMA' },
      { label: 'Sürücü', value: 'SURUCU' },
      { label: 'Plaka', value: 'PLAKA' },
      { label: 'AraçTeslimTarihi', value: 'ARAC_TESLIM_TARIHI' },
    ];

    // Başlıkları içeren bir array oluşturuyoruz
    const sheetData = [headers.map(header => header.label), ...ExportData.map(item => headers.map(header => item[header.value]))];

    // Excel dosyasını oluşturma
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

    // Excel dosyasını indirme
    XLSX.writeFile(workbook, 'Envanter.xlsx');
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      endIcon={<CloudDownloadIcon />}
      onClick={handleExport}
    >
      Excel
    </Button>
  );
}

export default ExcelExportScrapReport;
